import React, { useState } from "react";
import "./Login.css"; // Make sure to create a corresponding CSS file
import axios from "axios";
import GetServerAddress from "../../../functions/GetServerAddress";
import { ConsultantuseAuth } from "../../security/ConsultantUseAuth";
import { useParams } from "react-router-dom";
import GetClientAddress from "../../../functions/GetClientAddress";

const LoginConsultant = () => {
  const { urlUsername } = useParams();
  const { urlPassword } = useParams();

  const [Username, setUsername] = useState(
    urlUsername && urlUsername.length > 0 ? urlUsername : ""
  );
  const [Password, setPassword] = useState(
    urlPassword && urlPassword.length > 0 ? urlPassword : ""
  );
  const { loginConsultant } = ConsultantuseAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Here you would usually send a request to your backend to authenticate the user.
    try {
      const response = await axios.post(
        GetServerAddress() + "api/consultant/login",
        {
          dbName: "IP",
          collctiontext: "EC",
          search: {
            Username: Username,
            Password: Password,
          },
          limit: 100,
          fields: {
            MetaData: 1,
            BasicInfo: 1,
            _id: 1,
          },
        }
      );

      // Handle response here (e.g., navigate to another page, display a message)
      if (response.data.data.length === 0) {
        alert("Invalid Username or Password");
      } else if (response.data.data.length === 1) {
        await loginConsultant(response.data.data, response.data.token);
      } else if (response.data.data.length > 1) {
        alert(
          "Found more than 1 account? Please speak to your IT Department and alert them of this issue"
        );
      }
    } catch (error) {
      // Handle error here (e.g., display an error message)
      console.error("Login error", error);
      alert(
        "Login error, please tell IT department if this issue persists",
        error
      );
    }
  };

  const handleGetPassword = async (e) => {
    e.preventDefault();
    if (
      !Username ||
      Username === null ||
      Username.length === 0 ||
      Username === "" ||
      Username === undefined
    ) {
      alert("Please enter your email in the Username Field first");
    } else {
      try {
        const response = await axios.post(
          GetServerAddress() + "api/consultant/create_get_consultant_password",
          {
            Username: Username,
          }
        );

        // Handle response here (e.g., navigate to another page, display a message)
        if (response.data) {
          alert(response.data.message);
        }
      } catch (error) {
        // Handle error here (e.g., display an error message)
        console.error("Login error", error);
        alert(
          "Login error, please tell IT department if this issue persists",
          error
        );
      }
    }
  };

  const [welcomeText, setwelcomeText] = useState(false);

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Consultant Login</h2>
         <h3>Our new portal is now availible!</h3>

         <h3>
        <a 
          href="https://dukesinternalv3.onrender.com/Consultant/LoginConsultant"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#007bff", textDecoration: "underline" }}
        >
          https://dukesinternalv3.onrender.com/Consultant/LoginConsultant
        </a>
      </h3>
        {/* <div className="form-group">
          <label htmlFor="Username">Username</label>
          <input
            type="text"
            id="Username"
            value={Username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="Password">Password</label>
          <input
            type="Password"
            id="Password"
            value={Password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit">Login</button>
        <br></br>
        <br></br>
        <button onClick={(e) => handleGetPassword(e)}>
          Forget / Get Password
        </button>
        <br></br>
        <br></br>
        {welcomeText ? (
          <>
            <p style={{ textAlign: "center" }}>
              Enter your email into the "Username" fields and click "Forget /
              Get Password". You will be prompted in one of the following ways:
              <br></br> <br></br>1{")"} If your email is recognised and unique,
              you will be sent an email containing your password.
              <br></br> <br></br>2{")"} If your email is not unique, this means
              we may not have your personal email on record. Please email
              international@investin.org with your full name, your company name
              and your personal email so we may create/update your information.
              <br></br> <br></br>3{")"} If your email is not recognised, please
              email international@investin.org with your full name, your company
              name and your personal email so we may create/update your
              information.
            </p>
          </>
        ) : (
          <>
            <button onClick={(e) => setwelcomeText(true)}>
              First Time here?
            </button>
          </>
        )} */}
      </form>
    </div>
  );
};

export default LoginConsultant;
